export default {"cs":0.04,"de":0.91,"en":1,"es":0.79,"et":0.46,"fr":0.06,"nb-NO":0.04,"ru":0.13,"ta":0.86,"uk":0.3,"zh-Hant":0.27,"ja":0,"zh-Hans":0}